export default __webpack_public_path__ + "static/media/D.bb0b88c3.png";